<div class="admin-servers ziro-admin-page-content">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <div class="col-md-10 offset-md-1 pb-2 ziro-datatable-content">
      <ziro-breadcrumbs></ziro-breadcrumbs>
      @if (getBadServers().length > 0) {
        <div
          class="alert alert-danger"
          data-automation="server-misconfiguration-error"
          [innerHTML]="
            'tkey;admin.servers.invalid_configuration.label'
              | escapeHtml: { invalidServers: String(getBadServers().length) }
          "
        ></div>
      }

      <ziro-datatable
        [class]="'ziro-card'"
        [dataAutomation]="tableDataAutomation"
        [columns]="columns"
        [rowDataSource]="data"
        [uniqueRowIdentifier]="null"
        [showCustomAlert]="true"
        [setColumnWidths]="false"
        [resetPageOnDataChange]="false"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.servers.server.type.label'"
          [items]="typeOptions"
          [matchFn]="isTypeMatch"
          [dataAutomation]="'cisco-servers-type-filter'"
          [tableId]="'cisco-servers'"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;system_status.server.status'"
          [items]="statusOptions"
          [matchFn]="isStatusMatch.bind(this)"
          [dataAutomation]="'cisco-servers-status-filter'"
          [tableId]="'cisco-servers'"
        ></ziro-datatable-multi-select-filter>
        <div alert-content [innerHtml]="'tkey;datatable.no_color.no_results' | escapeHtml"></div>
      </ziro-datatable>
    </div>
  }
</div>

<ziro-bottom-nav></ziro-bottom-nav>
